import PropTypes from 'prop-types';

const propType = {
  code: PropTypes.string,
  decimal_digits: PropTypes.number,
  name: PropTypes.string,
  name_plural: PropTypes.string,
  rounding: PropTypes.number,
  symbol: PropTypes.string,
  symbol_native: PropTypes.string,
};

export default { propType };
